
const LoadingState = () => {
  return (
    <div className="flex justify-center items-center py-10">
      <div className="animate-spin h-8 w-8 border-4 border-clustr-blue border-t-transparent rounded-full"></div>
    </div>
  );
};

export default LoadingState;
